import Retailer from '@/utilities/retailerHelper.js'

export default function retailerCarSalesBlocker(to, _, next) {
  const isCarSales = Retailer.isCarSales()

  if (isCarSales === false) {
    next()
    return
  }

  // Car sales retailer - check if route is allowed
  if (Retailer.canAccessRouteMeta(to.meta)) {
    next()
    return
  }

  // Route not allowed for car sales retailers
  next({
    name: 'retailer.dashboard'
  })
}
